export default `
  id
  thumbnailSrc
  src
  type
  altText
`
